import { render, staticRenderFns } from "./TopicListItem.vue?vue&type=template&id=fad66368"
import script from "./TopicListItem.vue?vue&type=script&lang=js"
export * from "./TopicListItem.vue?vue&type=script&lang=js"
import style0 from "./TopicListItem.vue?vue&type=style&index=0&id=fad66368&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports